const parents = {
  tabs: {
    history: 'היסטוריה',
    information: 'מידע',
  },

  headerButtons: {
    create: {
      createBtn: 'הוסף',
    },
  },

  modal: {
    header: 'שנה סטטוס',
    body: 'Are you sure you want to change the parent status to ',
  },

  deleteModal: {
    header: 'מחק הורים',
    body: 'אתה עומד למחוק {{num}} הורים.',
  },

  edit: {
    tabs: {
      information: 'מידע כללי',
      linkStudent: 'תלמידים',
      history: 'היסטוריה',
    }
  },

  table: {
    statuses: {
      active: 'פעיל',
      inactive: 'לא פעיל',
    },

    actions: {
      delete: 'מחק',
    },

    header: {
      createBtn: 'הוסף',
      name: 'שם',
      email: 'אימייל',
      phone: 'טלפון',
      status: 'סטטוס',
      address: 'כתובת',
      createdBy: 'נוצר על ידי',
      createdAt: 'נוצר בתאריך',
    },
  },
  form: {
    header: {
      create: {
        title: 'הוסף',
      },

      update: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    actions: {
      header: 'פעולות',
      buttons: {
        resetPassword: 'איפוס סיסמה',
      },
    },

    create: {
      toasts: {
        success: 'הורה נוצר בהצלחה',
        error: 'אירעה שגיאה בעת יצירת ההורה',
      },
    },
    update: {
      activeStatus: {
        statusActive: 'פעיל',
        statusDeactivate: 'לא פעיל',
      },

      suspend: {
        actionActivate: 'בטל השעיה',
        actionDeactivate: 'השעיה',
        suspendModal: {
          popupTitleDeactivation: 'השעיית נוסע',
          popupTitleActive: 'סיבת השעיה',
          popupTitleUnsuspend: 'סיבת ביטול השעיה',
          popupSubTitleDeactivation: 'בחר את סיבת ההשעיה',
          popupActionActive: 'בטל השעיית נוסע',
          popupActionDeactivate: 'השעיית נוסע',
        },
      },
      toasts: {
        success: 'הורה עודכן בהצלחה',
        error: 'אירעה שגיאה בעת עדכון ההורה',
        fetchError: 'משהו השתבש\nאנא נסה שוב.',
      },
    },
    sections: {
      groups: {
        header: 'אתר ופרופיל',
        fields: {
          profile: {
            label: 'פרופיל',
          },
        },
      },
      personalDetails: {
        header: 'פרטים אישיים',
        fields: {
          firstName: {
            label: 'שם פרטי',
          },
          lastName: {
            label: 'שם משפחה',
          },
          email: {
            label: 'אימייל',
          },
          phone: {
            label: 'טלפון',
          },
          additionalPhone: {
            label: 'טלפון נוסף',
          },
          address: {
            label: 'כתובת',
          },
        },
      },
      linkStudent: {
        header: 'תלמידים',
        add: 'הוסף',
        entity: 'תלמידים',
      },
    },
  },

  studentsTable: {
    headers: {
      name: 'שם',
      address: 'כתובת',
      phone: 'טלפון',
      email: 'אימייל',
    },
  },
};

export default parents;
